import { render, staticRenderFns } from "./LerenLeren.vue?vue&type=template&id=1940d372&scoped=true&"
import script from "./LerenLeren.vue?vue&type=script&lang=js&"
export * from "./LerenLeren.vue?vue&type=script&lang=js&"
import style0 from "./LerenLeren.vue?vue&type=style&index=0&id=1940d372&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1940d372",
  null
  
)

export default component.exports